import React, { Component, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import FlatList from 'flatlist-react';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Typo from '../../components/CustomTypo';
import { Grid, Menu, ListItem, ListItemIcon, ListItemText, Button, TextField } from '@material-ui/core';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import { TimeIcon, BackIcon, MopedIcon, PlaceIcon, PhoneIcon, ErrorIcon, EditWhiteSmallIcon, DeliveryIcon, SuccessIcon } from '../../components/icons'
import GoogleMapComponent from '../../components/GoogleMapComponent';
import GoogleMapMarker from '../../components/GoogleMapMarker';
import Divider from '../../components/Divider'
import { formatDateTimeFrEpoch, formatTimeFrEpoch } from '../../utils/util';
import Container from '../../components/Container';
import { clearOrder, getOrderCache, order_key, setOrderCache } from '../../utils/order_cache';
import { callCartItemListeners, callRefreshMyOrderListeners, getCurrency, getLogo, getTopupInfo, setTopupInfo } from '../../utils/common';
import crmservices from '../../wsclient/crmservices';
import ModalAlert from '../../components/ModalAlert';
class ProcessTopupSecure extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoading: false,
            message: {},
            ready: false,
            wallet: {}
        }
        this.showMessage = this.showMessage.bind(this);
    }
    async UNSAFE_componentWillMount() {
        this.setState({ showLoading: true });
        let path = window.location.pathname;
        let topupInfo = getTopupInfo();
        let token = topupInfo && topupInfo.token? topupInfo.token:null;
        //let arr = path.split('/');
        //console.log('TopupWalletSecure topupInfo=', topupInfo);
        //console.log('TopupWalletSecure token=', token);
        //console.log('TopupWalletSecure path=', path);
        if(token && path && path.search(token)>0){
            this.setState({ready: true})
            await this.onTopup();
            this.setState({ showLoading: false });
        }
    }
    async onLoadWallet() {
        try {
            var result = await crmservices.account.getWalletInfo();
           // console.log("AAAAAA load wallet:",result);
            if (result.code === 'OK') {
                this.setState({ wallet: result.data.wallet });
            }
        } catch (error) {
            console.log("load contact error:", error);
        }
    }

    async onTopup(){
        const { t } = this.props;
        let date = (new Date()) / 1000;
        let topupInfo = getTopupInfo();
        if (!topupInfo){
            return;
        }
        let pathName = window.location.pathname;
        if (!pathName.includes('success')) {
            this.showMessage(true, t('EXCEPTION_PROCESS'))
            this.setState({isTopupSuccess: false})
            return;
        }
        let body = {
            wallet_id: topupInfo.wallet_id,
            topup_date: date.toFixed(0),
            amount: Number(topupInfo.amount),
            payment_method_id: topupInfo.payment_method_id,
        }
        try {
            let result = await crmservices.account.topUpWallet(body);
            if (result.code == 'OK') {
                await this.onLoadWallet();
                setTopupInfo({})
                //this.showMessage(true, t('TOPUP_SUCCESS'))
                this.setState({amount: '', isTopupSuccess: true})
            }
            else if (result.code=='PAYMENT_GATEWAY_EXCEPTION') {
                this.setState({isTopupSuccess: false})
                //this.showMessage(true, t('TOPUP_FAILED'))
            }
            else {
                this.showMessage(true, t('EXCEPTION_PROCESS'))
                this.setState({isTopupSuccess: false})
            }
        }
        catch (e) {
            console.log(' Topup Error: ', e)
            this.showMessage(true, t('EXCEPTION_PROCESS'))
        }
    }
    showMessage(status, message) {
        this.setState({
            showLoading: false,
            showLoadingProcess: false,
            message: {
                show: status,
                content: message ? message : null
            }
        })
    }

    render() {
        const { classes, t } = this.props;
        let currency = getCurrency();
        if(this.state.ready)
            return (
                <Container showLoading={this.state.showLoading}>
                    <Grid xs={12} item justify='center' container>
                        <Grid xs={12} sm={12} md={8} lg={6} item>
                        <Grid xs={12} item justify='center' container style={{ marginTop: 16 }}>
                                    {this.state.isTopupSuccess == true && <SuccessIcon style={{ width: 100, height: 100 }} />}
                                    {this.state.isTopupSuccess == false && <ErrorIcon style={{ width: 100, height: 100 }} />}
                        </Grid>
                        <Grid xs={12} item justify='center' container style={{ marginBottom: 16 }}>
                                    {this.state.isTopupSuccess == true && <Typo color="onPrimary" variant="subtitle1" mg_top_xl>{t('TOPUP_SUCCESS')}</Typo>}
                                    {this.state.isTopupSuccess == false && <Typo color="onPrimary" variant="subtitle1" mg_top_xl>{t('TOPUP_FAILED')}</Typo>}
                        </Grid>
                        <Grid xs={12} item justify='center'>
                            <Typo color='onPrimary' variant='h2' center mg_top_xl>{currency}{this.state.wallet && this.state.wallet.balance ? this.state.wallet.balance.toFixed(2) : "0.00"}</Typo>
                            <Typo color='label' variant='body1' center>{t('current_balance')}</Typo>
                        </Grid>
                        </Grid>
                        </Grid>
                    {this.state.message && <ModalAlert
                        open={this.state.message.show}
                        onClose={this.showMessage}
                        message={this.state.message.content}
                    />}
                </Container >
            );
        else{
            return(
                <Container showLoading={this.state.showLoading}>

                </Container>
            )
        }    

    }
}






const styles = theme => ({
    content: {
        margin: theme.spacing(4, 0, 4, 0)
    },
    footer: {
        position: 'fixed',
        bottom: theme.spacing(5),
        width: '47%',
        [theme.breakpoints.down('md')]: {
            width: '54%'
        },
        [theme.breakpoints.down('sm')]: {
            width: '63%'
        },
        [theme.breakpoints.down('xs')]: {
            width: '81%'
        }
    },
    row: {
        margin: theme.spacing(2, 0, 2, 0)
    },
    item_image: {
        width: theme.spacing(9),
        height: theme.spacing(9),
        objectFit: 'containt',
        borderRadius: theme.spacing(9),
    },
    item_image_container: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        borderRadius: theme.spacing(10),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing(5),
        backgroundColor: theme.palette.background.secondary,
    },
    listItem: {
        marginTop: theme.spacing(7)
    },
    item: {
        margin: theme.spacing(5, 0, 5, 0)
    },
    item_icon_container: {
        // marginLeft: 10,
        width: 40,
        height: 40,
        borderRadius: 40,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing(5) + 10,
        backgroundColor: theme.palette.button.category.backgroundColor,
    },
});
export default withStyles(styles)(withTranslation()(ProcessTopupSecure));